// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__20Z2i","errorLogs":"EditorFooter_errorLogs__3jaxB"};